import React, { useEffect, useState } from "react";
import "../Components/Herosectionpage.css";
import Mapboxpage from "./Mapboxpage";
import  carImg from "../../src/Components/images/car1.jpeg"
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase-config";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"
const Herosectionpage = () => {
const [Airporttransfersservices, AirporttransfersServices] = useState([]);
const headerData = Airporttransfersservices[0]; 
const [loading, setLoading] = useState(true);

useEffect(() => {
  const fetchServices = async () => {
    try {
      setLoading(true);
      const q = query(
        collection(db, "ownerPageDatas"),
        where("selectedmenutype", "==", "HomePage")
      );
      const querySnapshot = await getDocs(q);
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      AirporttransfersServices(data);
    } catch (error) {
      toast.error.error(error);
    } finally {
      setLoading(false); // ✅ important
    }
  };

  fetchServices();
}, []);

  // 👇 Loader here
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
      </div>
    );
  }
  return (
 <>
  <ToastContainer position="top-right" autoClose={2000} />

  <div
    className="mainhero-container"
    style={{
      backgroundImage: `url(${headerData?.image || carImg})`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    }}
  >
  <div className="mainhero-content">

  <h1>
  <span >
    {headerData?.headerTitle?.split(" ")[0] || "Experience"}
  </span>{" "}
  <span style={{ color: "#60BB5B" }}>
  {headerData?.headerTitle?.split(" ").slice(1).join(" ") || "MAS Mobility Service"}
  </span>
</h1>
   <p>
  {headerData?.headerDescription || "Premium Affordable  Services & Car Rental with Delivery.."}
</p>
</div>
<br/>
    <Mapboxpage/>
    </div>
     </>
  );
};

export default Herosectionpage;